import React from 'react';
import { object, string } from 'prop-types';

import clsx from 'clsx';

import { get, isString } from 'lodash';

import Tooltip from '@material-ui/core/Tooltip';

import IssueTypeIcons from './IssueTypeIcons';

import moment from 'moment';

import classes from './ServiceItemList.module.css';
import { getTimeZoneAbbr } from '../../../helpers/timezones';

const HealthIcon = ({health}) => {
    if (!isString(health)) return <span className={clsx(classes.healthIcon, classes.empty)} />;

    switch (health.toLowerCase()) {
        case 'high':
            return (
                <span className={clsx(classes.healthIcon, classes.high)} />
            );
        case 'medium':
            return (
                <span className={clsx(classes.healthIcon, classes.medium)} />
            );
        case 'low':
            return (
                <span className={clsx(classes.healthIcon, classes.low)} />
            );
        default:
            return (
                <span className={clsx(classes.healthIcon, classes.empty)} />
            );
    }
};

const ServiceItemListItem = ({
    activeClass,
    animatedClass,
    eventData,
    handleItemClick,
    sortBy,
    ...props
}) => {
    const renderNames = () => {
        const clientName = get(eventData, 'relatedClient.name', null);
        const siteName = get(eventData, 'relatedSite.name', null);
        const requesterName = get(eventData, 'requesterName', null);

        if (clientName && siteName && requesterName) {
            return `${clientName}, ${siteName}: ${requesterName}`;
        }

        if (clientName && requesterName && !siteName) {
            return `${clientName}: ${requesterName}`;
        }

        if (clientName && siteName && !requesterName) {
            return `${clientName}, ${siteName}`;
        }

        return clientName;
    };

    return (
        <li
            className={clsx(classes.serviceItem, activeClass, animatedClass)}
            role="none"
            onClick={handleItemClick}
        >
            <div className={classes.serviceItemTitle}>
                <div>
                    <HealthIcon
                        health={eventData.priority}
                    />
                    <Tooltip
                        title={
                            <React.Fragment>
                                <span className={classes.tooltip}>
                                    {renderNames()}
                                </span>
                            </React.Fragment>
                        }
                        placement="top-start"
                    >
                        <span>{renderNames()}</span>
                    </Tooltip>
                </div>
                <div className={classes.status}>
                    {eventData.status}
                </div>
            </div>
            <div className={classes.serviceItemDetails}>
                <Tooltip
                    title={
                        <React.Fragment>
                            <span className={classes.tooltip}>{eventData.summary || 'Summary Here'}</span>
                        </React.Fragment>
                    }
                    placement="top-start"
                >
                    <div style={{width: '55%'}}>
                        {eventData.summary || 'Summary Here'}
                    </div>
                </Tooltip>
                <div style={{width: '45%', textAlign: 'right'}}>
                    {
                        sortBy === 'insertTimestamp' ?
                            moment.utc(eventData.insertTimestamp).local().format('h:mm:ss A') + ' ' + getTimeZoneAbbr(eventData.insertTimestamp, moment.tz.guess()) :
                            moment.utc(eventData.lastModifiedTimestamp).local().format('YYYY-MM-DD h:mm:ss A') + ' ' + getTimeZoneAbbr(eventData.lastModifiedTimestamp, moment.tz.guess())
                    }
                </div>
            </div>
            <div className={classes.serviceItemIcons}>
                <IssueTypeIcons
                    issues={eventData.issueTypes}
                />
                <div className={classes.iconBundle}>
                    {
                        eventData.locked &&
                        <img src="/assets/images/lockFlat.svg" alt="locked" />
                    }
                    <div className={classes.badge}>
                        {eventData.appointmentCount}
                    </div>
                </div>
            </div>
        </li>
    );
};

ServiceItemListItem.defaultProps = {
    eventData: {},
    sortBy:    'insertTimestamp'
};

ServiceItemListItem.propTypes = {
    eventData: object,
    sortBy:    string
};

export default ServiceItemListItem;
